import { useEffect, useState } from "react";
import styled from "styled-components";
import axios from "axios";
import { useNavigate } from "react-router-dom";

function MyCourseBasicInfo(props) {
  const history = useNavigate();
  const [myCourseName, setMyCourseName] = useState(null);
  const [courseProgress, setCourseProgress] = useState(props.progress);
  const [courseIDProp, setCourseIDProp] = useState(props.courseID);
  const [courseState, setCourseState] = useState(null);
  const [daysUntilExpiration, setMyExpiration] = useState("");

  useEffect(() => {
    setCourseIDProp(props.courseID);
  }, [props.courseID]);

  useEffect(() => {
    setCourseProgress(props.progress);
  }, [props.progress]);

  useEffect(() => {
    if(props.expiresOn !== ""){
      const daysUntilExpiration = (new Date(props.expiresOn) - new Date()) / (1000 * 60 * 60 * 24);
      if (daysUntilExpiration <= 0){
        setMyExpiration("EXPIRED")
      } else if (daysUntilExpiration <= 1){
        setMyExpiration(`Expires in ${Math.floor(daysUntilExpiration*24)} hours` )
      } else if (daysUntilExpiration <= 60) {
        setMyExpiration(`Expires in ${Math.floor(daysUntilExpiration)} days`)
      } else {
        setMyExpiration("")
      }
    }
  }, [props.expiresOn])

  useEffect(() => {
  if (!courseIDProp) return;
  const controller = new AbortController();

  axios
    .post(
      "/returnMyCoursesInformation",
      { courseId: courseIDProp },
      { signal: controller.signal }
    )
    .then((res) => {
      setMyCourseName(res.data.name);
      setCourseState(res.data.state);
    })
    .catch((err) => {
      if (
        err?.name === "CanceledError" || err?.name === "AbortError" || err?.message === "canceled"
      ) return;

      console.error("returnMyCoursesInformation failed:", err);
    });

  return () => controller.abort();
}, [courseIDProp]);


  const onClickShowCourseContent = (courseID) => {
    history("/coursecontent", { state: { courseID, myCourseName } });
  };

  return (
    <Container>
      {daysUntilExpiration && ( <ExpirationDate>{daysUntilExpiration}</ExpirationDate> )}
      {courseIDProp && (
        <MyCourse
          onClick={daysUntilExpiration !== "EXPIRED" ?  () => onClickShowCourseContent(courseIDProp) : undefined}
          style={{
            cursor: daysUntilExpiration !== "EXPIRED" ? "pointer" : "not-allowed",
            opacity: daysUntilExpiration !== "EXPIRED" ? 1 : 0.3,
          }}
        >
          {myCourseName && ( <CourseNameContainer>{myCourseName}</CourseNameContainer> )}
          {courseState  && ( <CourseStateContainer>{courseState}</CourseStateContainer> )}
          {courseProgress != null && (
            <CourseProgressContainer>
              <ProgressBar>
                <div
                  style={{
                    height: "10px",
                    width: `${courseProgress}%`,
                    backgroundColor: daysUntilExpiration !== "EXPIRED" ? "rgba(95, 176, 95, 1)" : "grey",
                    borderRadius: "50px",
                  }}
                >
                </div>
              </ProgressBar>
            </CourseProgressContainer>
          )}
        </MyCourse>
      )}
    </Container>
  );
}

export default MyCourseBasicInfo;

const Container = styled.div`
  position: relative;
  display: inline-block; /* so it hugs the card width */
`;
const MyCourse = styled.div`
  position: relative;
  border-radius: 4px;
  border: 1px solid #adadad;
  height: 250px;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.2);
  display: grid;
  grid-template-rows: 1fr 1fr 1fr;
  cursor: pointer;
`;
const ExpirationDate = styled.div`
  position: absolute;
  top: -10px;
  right: -10px;
  z-index: 1;

  height: 30px;
  width: 140px;
  border-radius: 10px;
  border: 2px solid #adadad;
  color: white;
  background-color: #FF6275;

  display: flex;
  align-items: center;
  justify-content: center;
`;


const CourseNameContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 20px;
  margin-right: 20px;
`;

const CourseProgressContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  /* width: 100%; */
  margin-left: 20px;
  margin-right: 20px;
`;
const ProgressBar = styled.div`
  height: "10px";
  width: 80%;
  border: 1px solid gray;
  border-radius: 50px;
`;

const CourseStateContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 20px;
  margin-right: 20px;
  text-transform: capitalize;
`;
